import React from "react";
import { Row, Col, Container } from "react-bootstrap";

const Stepper = ({ currentStep, steps }) => {
  return (
    <Container
      className="stepper-container py-3 rounded"
      style={{ backgroundColor: "#EAFBF6", borderRadius: "8px" }}
    >
      <Row className="justify-content-center text-center">
        {steps.map((step) => (
          <Col
            key={step.step}
            xs={4}
            className="d-flex flex-column align-items-center"
          >
            <div
              className={`circle ${
                currentStep > step.step
                  ? "completed"
                  : currentStep === step.step
                  ? "current"
                  : "incomplete"
              }`}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor:
                  currentStep > step.step
                    ? "#004AAD"
                    : currentStep === step.step
                    ? "transparent"
                    : "#C4C4C4",
                border:
                  currentStep === step.step ? "4px solid #004AAD" : "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {currentStep === step.step && (
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    backgroundColor: "#004AAD",
                  }}
                ></div>
              )}
            </div>
            <span
              className="mt-2"
              style={{ color: "#004AAD", fontWeight: 500 }}
            >
              {step.label}
            </span>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Stepper;
